import EventEmitter from "base/EventEmitter";

export default class Measurements extends EventEmitter {
    constructor($element) {
        super();

        this.$element = $element;
        this.$container = this.$element.find('.js-measurements-container');

        this.bindEvents();
    }

    buildForm(measurements) {

        if (measurements.length <= 0) {
            measurements.push({width: "", drop: "", unit: "cm"});
        }

        if (measurements.length <= 1) {
            this.$container.addClass('single-measurement');
        } else {
            this.$container.removeClass('single-measurement');
        }

        this.$container.html('');

        measurements.forEach((measurement, index) => {
            this.$container.append(this.buildMeasurementElement(measurement, index));
        });

        this.emit('build');
    }

    addMeasurement() {
        this.$container.append(this.buildMeasurementElement({width: "", drop: "", unit: "cm"}, this.$container.find('.js-measurement').length));
        this.$container.removeClass('single-measurement');
        this.emit('add');
    }

    removeMeasurement(index) {
        this.$container.find('.js-measurement').eq(index).remove();
        this.buildForm(this.getMeasurements());
        this.emit('remove');
    }

    getMeasurements() {
        let measurements = [];

        this.$container.find('.js-measurement').each(function () {
            let $this = $(this);
            let measurement_info = {};

            measurement_info.width = $this.find('.js-width').val();
            measurement_info.drop = $this.find('.js-drop').val();
            measurement_info.unit = $this.find('.js-unit:checked').val();

            measurements.push(measurement_info);
        });

        return measurements;
    }

    bindEvents() {
        let me = this;

        this.$element.on('click', '.js-add-measurement', () => {
            this.addMeasurement();
            return false;
        }).on('click', '.js-remove-measurement', function () {
            let $this = $(this);
            let $measurement = $this.parents('.js-measurement');
            let index = $measurement.index();
            me.removeMeasurement(index);
            return false;
        });
    }

    buildMeasurementElement(measurement, index) {
        let cm_checked = measurement.unit === 'cm';
        let inches_checked = measurement.unit === 'inches';

        return (eotwJSXFactory('div', {className: "measurement js-measurement"}, [
            eotwJSXFactory('div', {className: "measurement__heading-wrap"}, [
                eotwJSXFactory('h3', {className: "measurement__heading"}, ["Window ", index + 1]),
                eotwJSXFactory('button', {type: "button", className: "measurement__remove-btn text-btn text-btn--red-hover js-remove-measurement"}, ["Remove"])
            ]),
            eotwJSXFactory('div', {className: "measurement__body"}, [
                eotwJSXFactory('div', {className: "measurement__form"}, [
                    eotwJSXFactory('div', {className: "measurement__field-wrap"}, [
                        eotwJSXFactory('div', {className: "field field--measurement"}, [
                            eotwJSXFactory('label', {className: "field__label"}, ["Width"]),
                            eotwJSXFactory('input', {type: "number", value: measurement.width, name: "window[" + index + "][width]", 'data-name': "width", step: ".1", className: "field__input js-width"}),
                            eotwJSXFactory('div', {className: "field__validation js-inline-validation"})
                        ]),
                        eotwJSXFactory('div', {className: "field field--measurement"}, [
                            eotwJSXFactory('label', {className: "field__label"}, ["Drop"]),
                            eotwJSXFactory('input', {type: "number", value: measurement.drop, name: "window[" + index + "][drop]", 'data-name': "drop", step: ".1", className: "field__input js-drop"}),
                            eotwJSXFactory('div', {className: "field__validation js-inline-validation"})
                        ])
                    ]),
                    eotwJSXFactory('fieldset', {className: "measurement__fieldset"}, [
                        eotwJSXFactory('label', {className: "measurement__radio field field--radio"}, [
                            eotwJSXFactory('input', {type: "radio", name: "window[" + index + "][unit]", value: "cm", checked: cm_checked, className: "field__input js-unit"}),
                            eotwJSXFactory('span', {className: "field__label"}, ["cm"])
                        ]),
                        eotwJSXFactory('label', {className: "measurement__radio field field--radio"}, [
                            eotwJSXFactory('input', {type: "radio", name: "window[" + index + "][unit]", value: "inches", checked: inches_checked, className: "field__input js-unit"}),
                            eotwJSXFactory('span', {className: "field__label"}, ["inches"])
                        ])
                    ])
                ])
            ])
        ]));
    }
}
